var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M.417 15a1.667 1.667 0 0 0 1.666 1.667h15.834A1.666 1.666 0 0 0 19.583 15V7.917a.209.209 0 0 0-.208-.209H.625a.208.208 0 0 0-.208.209V15Zm13.75-1.875h2.5a.625.625 0 1 1 0 1.25h-2.5a.625.625 0 0 1 0-1.25ZM3.75 9.792h6.667a.625.625 0 1 1 0 1.25H3.75a.625.625 0 1 1 0-1.25Zm0 3.333h2.5a.625.625 0 1 1 0 1.25h-2.5a.625.625 0 0 1 0-1.25ZM19.583 5a1.667 1.667 0 0 0-1.666-1.667H2.083A1.667 1.667 0 0 0 .417 5v1.25a.208.208 0 0 0 .208.208h18.75a.208.208 0 0 0 .208-.208V5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPaymentIcon);
export default __webpack_public_path__ + "static/media/add-payment-icon.98b1a2b4f24ccfdb3c6e7422fad04f4b.svg";
export { ForwardRef as ReactComponent };